<template>
  <div class="hashtag-generator-row">
    <div class="hashtag-generator-panel">
      <div class="form-panel">


        <div class="form-item">
          <label class="form-item-label" for="tone">Generate Num</label>
          <el-select id="num" v-model="num" placeholder="Select a Num">
            <el-option
                v-for="item in numOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

        </div>

        <div class="form-item">
          <label class="form-item-label" for="lang">Language</label>
          <el-select id="lang" v-model="lang" placeholder="Select a language">
            <el-option
                v-for="item in langOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

        </div>

        <div class="form-item">
          <label class="form-item-label" for="bio-desc">Generate hashtags for Description</label>
          <el-input
              id="bio-desc"
              type="textarea"
              v-model="desc"
              :autosize="{ minRows: 4, maxRows: 8}"
              placeholder="eg: When is the best time to have breakfast?"
          >

          </el-input>

          <el-button class="generate-btn" type="primary" @click="generateHandler" :loading="isLoading">Generate Your Hashtags</el-button>
        </div>
      </div>
      <div class="result-panel">
        <div class="form-item">
          <label class="form-item-label" for="bio-desc">Result</label>
          <el-input
              id="bio-desc"
              type="textarea"
              v-model="result"
              :disabled="true"
              :autosize="{ minRows: 11, maxRows: 11}"
              placeholder="Your generated hashtags will appear here..."
          >

          </el-input>
        </div>
        <el-button class="copy-btn" type="primary" @click="copyHandler"> Copy Hashtags </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { hashtagGeneratorAPI } from '@/api'
export default {
  name: 'HashtagGenerator',
  props: {
    msg: String
  },
  data() {
    return {
      // 状态
      isLoading: false,
      // 接口参数
      lang: 'en',
      num: 5,
      desc: '',
      result: '',
      // 配置参数
      langOptions: [
        {
          "label": "English",
          "value": "en"
        },
        {
          "label": "Chinese",
          "value": "zh"
        },
        {
          "label": "Spanish",
          "value": "es"
        },
        {
          "label": "French",
          "value": "fr"
        },
        {
          "label": "German",
          "value": "de"
        },
        {
          "label": "Italian",
          "value": "it"
        },
        {
          "label": "Japanese",
          "value": "ja"
        },
        {
          "label": "Russian",
          "value": "ru"
        },
        {
          "label": "Arabic",
          "value": "ar"
        },
        {
          "label": "Portuguese",
          "value": "pt"
        },
        {
          "label": "Korean",
          "value": "ko"
        },
        {
          "label": "Turkish",
          "value": "tr"
        },
        {
          "label": "Dutch",
          "value": "nl"
        },
        {
          "label": "Swedish",
          "value": "sv"
        },
        {
          "label": "Polish",
          "value": "pl"
        },
        {
          "label": "Danish",
          "value": "da"
        },
        {
          "label": "Finnish",
          "value": "fi"
        },
        {
          "label": "Greek",
          "value": "el"
        },
        {
          "label": "Hungarian",
          "value": "hu"
        },
        {
          "label": "Czech",
          "value": "cs"
        },
        {
          "label": "Romanian",
          "value": "ro"
        },
        {
          "label": "Slovak",
          "value": "sk"
        },
        {
          "label": "Bulgarian",
          "value": "bg"
        },
        {
          "label": "Croatian",
          "value": "hr"
        },
        {
          "label": "Estonian",
          "value": "et"
        },
        {
          "label": "Lithuanian",
          "value": "lt"
        },
        {
          "label": "Latvian",
          "value": "lv"
        },
        {
          "label": "Slovenian",
          "value": "sl"
        },
        {
          "label": "Maltese",
          "value": "mt"
        }
      ],
      numOptions: [
        {
          label: '5 Hashtags',
          value: 5,
        },
        {
          label: '10 Hashtags',
          value: 10,
        },
        {
          label: '20 Hashtags',
          value: 20,
        }
      ],
    }
  },
  methods: {
    async generateHandler() {
      if (!this.desc) {
        this.$message({
          message: 'Please input your description',
          type: 'warning'
        });
        return
      }
      // 调用接口
      this.isLoading = true
      try {
        const res = await hashtagGeneratorAPI(this.desc, this.num, this.lang)
        if (res && res.code === 100000) {
          this.result = res?.data?.tag.join('')
          this.$message({
            message: 'Generate Success!',
            type: 'warning'
          });
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    copyHandler() {
      let oInput = document.createElement('input')
      oInput.value = this.result
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('Copy')
      oInput.className = 'oInput'
      oInput.style.display = 'none'
      oInput.remove()

      this.$message({
        message: 'Copy Success',
        type: 'success'
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hashtag-generator-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  background-color: #f8fcff;
  padding: 40px 0;
}
.hashtag-generator-panel {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;

  width: 1140px;
  max-width: 1140px;
}
.form-panel {
  width: 400px;
  height: 390px;

  background: white;
  color: #0f172a;
  border-radius: 4px;
  box-shadow: 0 1px #0000000d;
  padding: 1.5em;

  border: rgba(0, 0, 0, 0.125) solid 1px;

}

.form-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  margin-bottom: 8px;
}

.form-item-label {
  font-weight: bold;
}

.generate-btn, .copy-btn {

  margin-top: 15px;
  width: 100%;

}

.result-panel {
  width: 400px;
  height: 390px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  background: white;
  color: #0f172a;
  border-radius: 4px;
  box-shadow: 0 1px #0000000d;
  padding: 1.5em;

  border: rgba(0, 0, 0, 0.125) solid 1px;

}

</style>
